import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { PushNotificationsDataService, PushNotificationsColumnsService } from '../../../services';
import { PushNotification, PushNotificationsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-push-notification-details',
  templateUrl: './push-notification-details.component.html',
  styleUrls: ['./push-notification-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class PushNotificationDetailsComponent implements OnInit, OnDestroy {

  public pushNotification: PushNotification = {};
  public pushNotifications: PushNotification[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private pushNotificationsDataService: PushNotificationsDataService,
    private pushNotificationsColumnsService: PushNotificationsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Push Notification - Details');
        this.getPushNotification(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.pushNotification !== 'undefined') {
      this.pushNotification = this.dynamicDialogConfig.data.pushNotification;
    }
    this.columns = this.pushNotificationsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getPushNotification(id: number): void {
    this.isLoading = true;
    this.pushNotificationsDataService.getPushNotification(id).subscribe((response: PushNotification|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.pushNotification = response;
      }
    });
  }

  list() {
    this.router.navigate(['/push-notifications']);
  }

  add() {
    this.router.navigate(['/push-notifications/add']);
  }

  edit() {
    this.router.navigate(['/push-notifications/edit/' + this.pushNotification.id]);
  }

}
@Component({
  selector: 'app-push-notification-details',
  templateUrl: './push-notification-details.component.html',
  styleUrls: ['./push-notification-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogPushNotificationDetailsComponent extends PushNotificationDetailsComponent {
}

